<template>
  <div>
    <v-autocomplete
      v-model="branchId"
      data-pptr="branch"
      background-color="white"
      class="text-sm"
      :error="hasErrorStore || error"
      :error-messages="errorMessages"
      :items="branchItems"
      :disabled="isDisabledSelectBranch"
      :filter="
        (item, queryText, itemText) => {
          const text = `${item.text}`
          return (
            text
              .toLocaleLowerCase()
              .indexOf(queryText.toLocaleLowerCase()) > -1
          )
        }
      "
      item-text="text"
      item-value="id"
      placeholder="เลือกสาขา"
      ref="branch_id"
      @change="change"
    ></v-autocomplete>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    branchType: {
      type: String,
      default: 'deposit',
    },
    error: {
      type: Boolean,
      default: false,
    },
    errorMessages: {
      type: String,
      default: '',
    },
  },

  computed: {
    ...mapState({
      branch: state => state.branchStore?.branchV2,
    }),

    branchItems() {
      return this.branch
        ?.map(item => ({
          ...item,
          text: `[${item?.province || ''}]  ${
            item.branch_code
          } ${item.name || ''}`,
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    },

    isDisabledSelectBranch() {
      return (
        this.$route.query.branch_id || this.$route.query.branch_code
      )
    },
  },

  watch: {
    branch() {
      if (this.$route.query.branch_code) {
        // find branch id
        const branch = this.branch.find(
          item =>
            +item.branch_code === +this.$route.query.branch_code,
        )
        this.branchId = branch?.id ?? null
        this.branchCode = +this.$route.query.branch_code ?? null
        this.$emit('change', this.branchId, this.branchCode)
      }
      if (this.$route.query.branch_id) {
        // find branch code
        const branch = this.branch.find(
          item => +item.id === +this.$route.query.branch_id,
        )

        this.branchId = +this.$route.query.branch_id ?? null
        this.branchCode = branch?.branch_code ?? null
        this.$emit('change', this.branchId, this.branchCode)
      }
      if (this.branchCode) {
        // find branch id
        const branch = this.branch.find(
          item => +item.branch_code === +this.branchCode,
        )
        this.branchId = branch?.id ?? null
        this.$emit('change', this.branchId, this.branchCode)
      }
    },
  },

  data() {
    return {
      branchId: null,
      branchCode: sessionStorage.getItem('bc') ?? null,
    }
  },

  async mounted() {
    await this.getData()
  },

  methods: {
    async getData() {
      await this.$store.dispatch('branchStore/getBranchV2', {
        slug: this.$route.params.slug,
        branchType: 'deposit',
      })
    },

    change() {
      const branch = this.branch.find(
        item => +item.id === +this.branchId,
      )
      this.$emit('change', this.branchId, branch.branch_code)
    },
  },
}
</script>
